import React, { Fragment } from 'react';
import { Box } from '@bechtel/gds';
import { Text } from '@bechtel/gds';
import { Icon, IconSize } from '@bechtel/gds';
import useOfflineStatus from '~/hooks/use-offline-status';
import { NetworkStatusStyled } from './styled';
import { Trans } from '@lingui/macro';

export const NetworkStatus = () => {
  const isOffline = useOfflineStatus();

  return (
    <Fragment>
      {isOffline && (
        <NetworkStatusStyled>
          <Box alignItems={{ sm: 'center' }}>
            <Icon size={IconSize.LARGE} icon="wifi-slash" />
            <Box ml={{ sm: '500' }}>
              <Text size="400" weight="600">
                <Trans>
                  We have detected that your network connection has been lost. This notification will close as soon as
                  we detect a stable connection.
                </Trans>
              </Text>
            </Box>
          </Box>
        </NetworkStatusStyled>
      )}
    </Fragment>
  );
};

// export default NetworkStatus;
